<template>
  <v-container>
    <v-sheet class="pa-7 mb-4" v-if="!is_add_score">
      <div class="d-flex align-center mb-5">
        <div class="form-title mr-5">{{$t('upload_sheet.basic_info')}}</div>
        <div class="errorstrong--text">{{$t('global.text.red_is_required')}}</div>
      </div>

      <v-divider></v-divider>
      <div class="d-flex">
        <v-menu v-model="menu" :close-on-content-click="false" offset-x>
          <template v-slot:activator="{ on }">
            <v-btn
              rounded
              class="white add-language-btn textcolor6--text mt-7"
              style="border-width: 1 !important; border-color: #e3e3e3 !important; border-style: solid !important; margin-right: 10px;"
              depressed
              v-on="on"
              height="26"
            >
              <div>{{$t('global.text.set_multiple_language')}}</div>
            </v-btn>
          </template>

          <v-card width="277">
            <m-selector-panel
              v-model="currentLanguage"
              v-on:onClose="menu = false"
              :items="languageList"
              :title="$t('global.text.choose_language')"
              :disableItem=" item => item.disable"
            ></m-selector-panel>
          </v-card>
        </v-menu>
      </div>
      <v-row class="mt-4">
        <!-- <v-col cols="6" v-if="false">
          <m-selector
            class="max-width-560 mb-5"
            v-model="selectedAlbum"
            :reminding="selectedAlbum == null && posted"
            :options="albums"
            disabled
            required
            :placeholder="$t('album.choose_album')"
          >
            <template v-slot:list-tile>
              <v-list-tile
                slot="prepend-item"
                v-on="on"
                class="ma-4 create-composer d-flex"
                @click="createAlbum"
              >{{'+ ' + $t('albums.table.add_album')}}</v-list-tile>
            </template>
          </m-selector>
        </v-col>-->
        <v-col cols="6">
          <m-text-input
            :language="getLanguage(language)"
            v-for="(language) in currentLanguage"
            :key="language"
            :reminding="(name[language] == null || name[language] == '') && posted"
            class="max-width-560 mb-4"
            required
            v-model="name[language]"
            :placeholder="$t('album.sheet_name')"
          ></m-text-input>
        </v-col>
      </v-row>
    </v-sheet>

    <v-sheet class="pa-7 mb-12">
      <div class="d-flex align-center">
        <div class="form-title mr-5">{{$t('upload_sheet.sheet')}}</div>
        <div class="errorstrong--text">{{$t('global.text.red_is_required')}}</div>
      </div>
      <div v-for="(score, index) in scores" :key="index">
        <v-divider class="my-5"></v-divider>

        <div class="d-flex" v-if="false">
          <div class="form-subtitle">· {{$t('upload_sheet.create_score')}}</div>
        </div>

        <div class="d-flex mt-5 score-name">
          <v-chip
            class="black white--text form-text-bold"
          >{{$t('upload_sheet.score', [`${score.sequence + 1}`])}}</v-chip>
        </div>

        <v-row no-gutters class="mt-5">
          <v-col cols="6">
            <m-selector
              class="mr-4"
              v-model="score.score_data.scoreName"
              :reminding="(score.score_data.scoreName == null) && posted"
              :options="scoreNames"
              :placeholder="$t('album.sheet.score_name')"
              :aaa="isDisableScoreName"
              :disableItems="isDisableScoreName"
              required
            ></m-selector>
          </v-col>

          <v-col cols="6">
            <div class="d-flex align-center">
              <div class="red-point mx-4"></div>

              <v-autocomplete
                class="composer-form tablegray"
                v-model="score.score_data.composer"
                color="primary"
                :label="$t('album.sheet.composer')"
                :items="composers"
                :filter="activeFilter"
                hide-details
                height="66"
                outlined
                :error="score.score_data.composer == null && posted"
                single-line
                :rules="[(v) => !!v || 'Gender is required']"
                required
              >
                <v-list-tile
                  slot="prepend-item"
                  v-on="on"
                  class="ma-4 create-composer d-flex"
                  @click="dialog = true"
                >{{'+ ' + $t('album.sheet.create_composer')}}</v-list-tile>

                <!-- {{$t('album.sheet.create_composer')}}
                </v-list-tile>-->
              </v-autocomplete>
            </div>

            <v-dialog v-model="dialog" persistent width="500">
              <template v-slot:activator="{ on }">
                <div></div>
              </template>

              <v-card class="pa-5">
                <div class="create-composer-title mb-4 d-flex justify-center">
                  <span>{{$t('album.sheet.create_composer')}}</span>
                </div>

                <div class="d-flex mb-4">
                  <v-text-field
                    hide-details
                    height="64"
                    outlined
                    :error="(composerName == null || composerName.length == 0) && composerPosted"
                    v-model="composerName"
                    :rules="[(v) => !!v || 'Gender is required']"
                    :label="$t('album.sheet.composer_name')"
                    required
                  ></v-text-field>
                </div>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="white"
                    text
                    class="primary"
                    rounded
                    :loading="createComposerLoading"
                    @click="createComposer(score.score_data)"
                  >{{ $t('global.text.create') }}</v-btn>
                  <v-btn
                    class="tablegray textcolor6--text"
                    rounded
                    text
                    @click="dialog = false"
                  >{{ $t('global.text.btn_cancel') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>

        <div class="d-flex mt-5"></div>
        <div class="d-flex mt-8">
          <div class="form-text-bold">{{$t('upload_sheet.sheet_file')}}</div>
          <div class="remindercolor--text">（{{$t('global.text.required')}})</div>
        </div>

        <div class="d-flex align-center mt-5">
          <div class="upload-file-title">MusicXML(.musicxml) {{$t('upload_sheet.file')}}</div>
          <file-input-button
            v-model="score.musicxmlFile.file"
            accept=".xml, .musicxml"
            v-on:fileUpdated="fileUpdated"
            :uuid="`file_musicXml_${index}`"
            :ref="`file_musicXml_${index}`"
          >
            <div
              :class="{'upload-file': true, 'd-flex': true, 'px-5': true, 'file-remind': !isExitMusicXMLFile(score) && posted}"
            >
              <div
                class="file-btn-title justify-start textcolor--text"
                v-if="!isExitMusicXMLFile(score)"
              >{{$t('upload_sheet.click_add_music_file')}}</div>
              <div
                class="file-btn-title justify-start textcolor--text"
                v-if="isExitMusicXMLFile(score)"
              >{{ getMusicXMLName(score) }}</div>
              <div
                v-if="isExitMusicXMLFile(score)"
                class="primary--text ml-auto"
                @click.stop="previewSheetShow(score, index)"
                v-on="on"
              >{{$t('upload_sheet.preview')}}</div>
              <!-- <v-dialog v-model="sheetDialog" v-if="isExitMusicXMLFile(score)">
                <template v-slot:activator="{ on }">
                  <div
                    class="primary--text ml-auto"
                    @click.stop="previewSheetShow(score, index)"
                    v-on="on"
                  >{{$t('upload_sheet.preview')}}</div>
                </template>
                <v-card class="white pa-4">
                    <div class="d-flex">
                        <v-btn class="ml-auto" icon width="20" height="20" dark @click="sheetDialog = false">
                            <v-img :src="img.close"></v-img>
                        </v-btn>
                    </div>
                  <div :ref="`sheetShow`" class="sheet-show" id="viewer"></div>
                </v-card>
              </v-dialog>-->
            </div>
          </file-input-button>
        </div>

        <div class="d-flex align-center mt-5">
          <div class="upload-file-title">MuseScore(.mscz) {{$t('upload_sheet.file')}}</div>
          <file-input-button
            accept=".mscz"
            v-model="score.museScoreFile.file"
            v-on:fileUpdated="fileUpdated"
            :uuid="`file_museScore_${index}`"
            :ref="`file_museScore_${index}`"
          >
            <div
              :class="{'upload-file': true, 'd-flex': true, 'px-5': true, 'file-remind': !isExitMuseScoreFile(score) && posted}"
            >
              <div
                v-if="!isExitMuseScoreFile(score)"
                class="file-btn-title justify-start textcolor6--text"
              >{{$t('upload_sheet.click_add_music_file')}}</div>
              <div
                v-if="isExitMuseScoreFile(score)"
                class="file-btn-title justify-start textcolor6--text"
              >{{ getMuseScoreName(score) }}</div>
            </div>
          </file-input-button>
        </div>

        <v-row>
          <v-spacer></v-spacer>
          <v-btn
            v-if="index == scores.length - 1 && index != 0"
            depressed
            color="errorlight"
            rounded
            :loading="loading"
            class="errorstrong--text"
            @click="deleteScore(score, index)"
          >{{$t('upload_sheet.delete_score')}}</v-btn>
        </v-row>
        <v-divider class="my-8"></v-divider>
      </div>
      <div class="d-flex align-center">
        <v-btn rounded class="white add-score-btn" depressed @click="addScore()" height="52">
          <img class="mr-4" :src="img.add" alt />
          <div>{{$t('upload_sheet.add_new_score')}}</div>
        </v-btn>

        <v-btn
          v-if="accompaniments.scores.length  == 0"
          rounded
          class="white add-score-btn ml-8"
          depressed
          @click="addAcc()"
          height="52"
        >
          <img class="mr-4" :src="img.add" alt />
          <div>{{ $t('upload_sheet.add_acc') }}</div>
        </v-btn>
      </div>

      <div class="d-flex mt-12" v-if="accompaniments.scores.length == 0">
        <v-btn
          class="btn-title mr-5"
          width="178"
          height="52"
          rounded
          depressed
          :loading="loading"
          color="primary"
          style="font-size: 20px"
          @click="submitSheet"
        >{{$t('global.text.submit')}}</v-btn>

        <v-btn
          class="btn-title textcolor6--text"
          width="178"
          height="52"
          rounded
          depressed
          style="font-size: 20px"
          @click="cancel"
        >{{$t('global.text.btn_cancel')}}</v-btn>
      </div>
    </v-sheet>

    <v-sheet class="pa-7 mb-12" v-if="accompaniments.scores.length > 0">
      <div>
        <div class="d-flex align-center">
          <div class="form-title mr-5">{{$t('upload_sheet.accompaniments')}}</div>
          <div class="errorstrong--text">{{$t('global.text.red_is_required')}}</div>
        </div>
        <v-divider class="my-8"></v-divider>

        <div v-for="(acc, index) in accompaniments.scores" :key="index">
          <v-row>
            <v-col cols="6">
              <m-selector
                class="mr-4"
                v-model="acc.score_data.scoreName"
                :reminding="(acc.score_data.scoreName == null) && posted"
                :options="accScoreNames"
                :placeholder="$t('album.sheet.score_name')"
                :disableItems="isDisableScoreName"
                required
              ></m-selector>
            </v-col>
            <v-col cols="6">
              <div class="d-flex align-center">
                <div class="red-point mx-4"></div>
                <v-autocomplete
                  class="composer-form tablegray"
                  v-model="acc.score_data.composer"
                  color="primary"
                  :label="$t('album.sheet.composer')"
                  :items="composers"
                  :filter="activeFilter"
                  hide-details
                  height="66"
                  outlined
                  :error="acc.score_data.composer == null && posted"
                  single-line
                  :rules="[(v) => !!v || 'Gender is required']"
                  required
                >
                  <v-list-tile
                    slot="prepend-item"
                    v-on="on"
                    class="ma-4 create-composer d-flex"
                    @click="dialog = true"
                  >{{'+ ' + $t('album.sheet.create_composer')}}</v-list-tile>
                </v-autocomplete>
              </div>

              <v-dialog v-model="dialog" persistent width="500">
                <template v-slot:activator="{ on }">
                  <div></div>
                </template>

                <v-card class="pa-5">
                  <div class="create-composer-title mb-4 d-flex justify-center">
                    <span>{{$t('album.sheet.create_composer')}}</span>
                  </div>

                  <div class="d-flex mb-4">
                    <v-text-field
                      hide-details
                      height="64"
                      outlined
                      :error="(composerName == null || composerName.length == 0) && composerPosted"
                      v-model="composerName"
                      :rules="[(v) => !!v || 'Gender is required']"
                      :label="$t('album.sheet.composer_name')"
                      required
                    ></v-text-field>
                  </div>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="white"
                      text
                      class="primary"
                      rounded
                      :loading="createComposerLoading"
                      @click="createComposer(score.score_data)"
                    >{{ $t('global.text.create') }}</v-btn>
                    <v-btn
                      class="tablegray textcolor6--text"
                      rounded
                      text
                      @click="dialog = false"
                    >{{ $t('global.text.btn_cancel') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>

          <div class="d-flex mt-5"></div>

          <div class="d-flex mt-8">
            <div class="form-text-bold">{{$t('upload_sheet.sheet_file')}}</div>
            <div class="remindercolor--text">（{{$t('global.text.required')}})</div>
          </div>

          <div class="d-flex align-center mt-5">
            <div class="upload-file-title">MusicXML(.musicxml) {{$t('upload_sheet.file')}}</div>
            <file-input-button
              v-model="acc.musicxmlFile.file"
              accept=".xml, .musicxml"
              v-on:fileUpdated="fileUpdated"
              :uuid="`acc_file_musicXml_${index}`"
              :ref="`acc_file_musicXml_${index}`"
            >
              <div
                :class="{'upload-file': true, 'd-flex': true, 'px-5': true, 'file-remind': !isExitMusicXMLFile(acc) && posted}"
              >
                <div
                  class="file-btn-title justify-start textcolor--text"
                  v-if="!isExitMusicXMLFile(acc)"
                >{{$t('upload_sheet.click_add_music_file')}}</div>
                <div
                  class="file-btn-title justify-start textcolor--text"
                  v-if="isExitMusicXMLFile(acc)"
                >{{ getMusicXMLName(acc) }}</div>
                <div
                  v-if="isExitMusicXMLFile(acc)"
                  class="primary--text ml-auto"
                  @click.stop="previewSheetShow(acc, index)"
                  v-on="on"
                >{{$t('upload_sheet.preview')}}</div>
              </div>
            </file-input-button>
          </div>

          <div class="d-flex align-center mt-5">
            <div class="upload-file-title">MuseScore(.mscz) {{$t('upload_sheet.file')}}</div>
            <file-input-button
              accept=".mscz"
              v-model="acc.museScoreFile.file"
              v-on:fileUpdated="fileUpdated"
              :uuid="`acc_file_museScore_${index}`"
              :ref="`acc_file_museScore_${index}`"
            >
              <div
                :class="{'upload-file': true, 'd-flex': true, 'px-5': true, 'file-remind': !isExitMuseScoreFile(acc) && posted}"
              >
                <div
                  v-if="!isExitMuseScoreFile(acc)"
                  class="file-btn-title justify-start textcolor6--text"
                >{{$t('upload_sheet.click_add_music_file')}}</div>
                <div
                  v-if="isExitMuseScoreFile(acc)"
                  class="file-btn-title justify-start textcolor6--text"
                >{{ getMuseScoreName(acc) }}</div>
              </div>
            </file-input-button>
          </div>

          <v-row>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="errorlight"
              rounded
              :loading="loading"
              class="errorstrong--text"
              @click="deleteScore(acc, index)"
            >{{$t('upload_sheet.delete_score')}}</v-btn>
          </v-row>
          <v-divider class="my-8"></v-divider>
        </div>
      </div>

      <div class="d-flex mt-12" v-if="accompaniments.scores.length > 0">
        <v-btn
          class="btn-title mr-5"
          width="178"
          height="52"
          rounded
          depressed
          :loading="loading"
          color="primary"
          style="font-size: 20px"
          @click="submitSheet"
        >{{$t('global.text.submit')}}</v-btn>

        <v-btn
          class="btn-title textcolor6--text"
          width="178"
          height="52"
          rounded
          depressed
          style="font-size: 20px"
          @click="cancel"
        >{{$t('global.text.btn_cancel')}}</v-btn>
      </div>
    </v-sheet>
    <v-dialog v-model="sheetDialog">
      <template v-slot:activator="{ on }"></template>
      <v-card class="white pa-4">
        <div class="d-flex">
          <v-btn class="ml-auto" icon width="20" height="20" dark @click="sheetDialog = false">
            <v-img :src="img.close"></v-img>
          </v-btn>
        </div>
        <div :ref="`sheetShow`" class="sheet-show" id="viewer"></div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import FileInputButton from "../components/common/FileInputButton";
import MTextInput from "../components/common/MTextInput";
import MSelector from "../components/common/MSelector";
import MSelectorPanel from "../components/common/MSelectorPanel";
import MTextFilter from "../components/common/MTextFilter";

import domtoimage from "dom-to-image-hm";
import "../musicxml-vexflow.js";

const originScoreNameMap = [
  {
    key: "violin",
    fullName: "小提琴",
    fullName_en: "Violin",
    shortName: "小提",
    shortName_en: "VIn.",
    instrument: "violin"
  },
  {
    key: "violinI",
    fullName: "第一小提琴",
    fullName_en: "Violin I",
    shortName: "一提",
    shortName_en: "Vn.I",
    instrument: "violin"
  },
  {
    key: "violinII",
    fullName: "第二小提琴",
    fullName_en: "Violin II",
    shortName: "二提",
    shortName_en: "Vn.II",
    instrument: "violin"
  },
  {
    key: "violinIII",
    fullName: "第三小提琴",
    fullName_en: "Violin III",
    shortName: "三提",
    shortName_en: "Vn.III",
    instrument: "violin"
  },
  {
    key: "violinIV",
    fullName: "第四小提琴",
    fullName_en: "Violin IV",
    shortName: "四提",
    shortName_en: "Vn.IV",
    instrument: "violin"
  },
  {
    key: "viola",
    fullName: "中提琴",
    fullName_en: "Viola",
    shortName: "中提",
    shortName_en: "Va.",
    instrument: "viola"
  },
  {
    key: "violaI",
    fullName: "第一中提琴",
    fullName_en: "Viola I",
    shortName: "中一",
    shortName_en: "Va.I",
    instrument: "viola"
  },
  {
    key: "violaII",
    fullName: "第二中提琴",
    fullName_en: "Viola II",
    shortName: "中二",
    shortName_en: "Va.II",
    instrument: "viola"
  },
  {
    key: "cello",
    fullName: "大提琴",
    fullName_en: "Cello",
    shortName: "大提",
    shortName_en: "Vc.",
    instrument: "cello"
  },
  {
    key: "celloI",
    fullName: "第一大提琴",
    fullName_en: "Cello I",
    shortName: "大一",
    shortName_en: "Vc.I",
    instrument: "cello"
  },
  {
    key: "celloII",
    fullName: "第二大提琴",
    fullName_en: "Cello II",
    shortName: "大二",
    shortName_en: "Vc.II",
    instrument: "cello"
  },
  {
    key: "celloIII",
    fullName: "第三大提琴",
    fullName_en: "Cello III",
    shortName: "大三",
    shortName_en: "Vc.III",
    instrument: "cello"
  },
  {
    key: "celloIV",
    fullName: "第四大提琴",
    fullName_en: "Cello IV",
    shortName: "大四",
    shortName_en: "Vc.IV",
    instrument: "cello"
  },
  {
    key: 'clarinet',
    fullName: "降B单簧管",
    fullName_en: "Clarinet in B♭",
    shortName: "黑管",
    shortName_en: "Cl.",
    instrument: "clarinet"
  },
  {
    key: 'clarinetI',
    fullName: "第一降B单簧管",
    fullName_en: "Clarinet in B♭ I",
    shortName: "黑一",
    shortName_en: "Cl.I",
    instrument: "clarinet"
  },
  {
    key: 'clarinetII',
    fullName: "第二降B单簧管",
    fullName_en: "Clarinet in B♭ II",
    shortName: "黑二",
    shortName_en: "Cl.II",
    instrument: "clarinet"
  },
  {
    key: 'piano',
    fullName: "钢琴",
    fullName_en: "Piano",
    shortName: "钢琴",
    shortName_en: "Pno.",
    instrument: "piano"
  },
  {
    key: 'Primo',
    fullName: "钢琴第一声部",
    fullName_en: "Primo",
    shortName: "一钢",
    shortName_en: "Pri.",
    instrument: "piano"
  },
  {
      key: 'Secondo',
    fullName: "钢琴第二声部",
    fullName_en: "Secondo",
    shortName: "二钢",
    shortName_en: "Sec.",
    instrument: "piano"
  },
  {
      key: 'pianoI',

    fullName: "第一钢琴",
    fullName_en: "Piano I",
    shortName: "钢一",
    shortName_en: "Pno I.",
    instrument: "piano"
  },
  {
      key: 'pianoII',
    fullName: "第二钢琴",
    fullName_en: "Piano II",
    shortName: "钢二",
    shortName_en: "Pno II.",
    instrument: "piano"
  },
  { key: 'flute', fullName: "长笛", fullName_en: "Flute", shortName: "长笛", shortName_en: "Fl.", instrument: "flute"},
  { key: 'fluteI', fullName: "长笛第一声部", fullName_en: "Flute I", shortName: "一笛", shortName_en: "Fl.I", instrument: "flute"},
  { key: 'fluteII', fullName: "长笛第二声部", fullName_en: "Flute II", shortName: "二笛", shortName_en: "Fl.II", instrument: "flute"},
  { key: 'saxophone', fullName: "萨克斯", fullName_en: "Saxophone", shortName: "萨克斯", shortName_en: "Sax", instrument: "saxophone"},
  { key: 'saxophoneI', fullName: "萨克斯第一声部", fullName_en: "Saxophone I", shortName: "萨克斯一", shortName_en: "Sax.I", instrument: "saxophone"},
  { key: 'saxophoneII', fullName: "萨克斯第二声部", fullName_en: "Saxophone II", shortName: "萨克斯二", shortName_en: "Sax.II", instrument: "saxophone"},
  { key: 'saxophoneIII', fullName: "萨克斯第三声部", fullName_en: "Saxophone III", shortName: "萨克斯三", shortName_en: "Sax.III", instrument: "saxophone"},
  { key: 'saxophoneIV', fullName: "萨克斯第四声部", fullName_en: "Saxophone IV", shortName: "萨克斯四", shortName_en: "Sax.IV", instrument: "saxophone"},
  { key: 'trumpet', fullName: "小号", fullName_en: "Trumpet", shortName: "小号", shortName_en: "Tpt.", instrument: "trumpet"},
  { key: 'trumpetI', fullName: "小号第一声部", fullName_en: "Trumpet I", shortName: "小号一", shortName_en: "Tpt.I", instrument: "trumpet"},
  { key: 'trumpetII', fullName: "小号第二声部", fullName_en: "Trumpet II", shortName: "小号二", shortName_en: "Tpt.II", instrument: "trumpet"},
  { key: 'trumpetIII', fullName: "小号第三声部", fullName_en: "Trumpet III", shortName: "小号三", shortName_en: "Tpt.III", instrument: "trumpet"},
  { key: 'horn', fullName: "圆号", fullName_en: "French Horn", shortName: "圆号", shortName_en: "Horn", instrument: "horn"},
  { key: 'hornI', fullName: "圆号第一声部", fullName_en: "French Horn I", shortName: "圆号一", shortName_en: "Horn.I", instrument: "horn"},
  { key: 'hornII', fullName: "圆号第二声部", fullName_en: "French Horn II", shortName: "圆号二", shortName_en: "Horn.II", instrument: "horn"},
  { key: 'hornIII', fullName: "圆号第三声部", fullName_en: "French Horn III", shortName: "圆号三", shortName_en: "Horn.III", instrument: "horn"},
  { key: 'hornIV', fullName: "圆号第四声部", fullName_en: "French Horn IV", shortName: "圆号四", shortName_en: "Horn.IV", instrument: "horn"},
];

const originAccScoreNameMap = [
  {
    key: "piano",
    fullName: "钢琴",
    fullName_en: "Piano",
    shortName: "钢琴",
    shortName_en: "Pno.",
    instrument: "piano"
  }
];

export default {
  data: function() {
    const scoreNameCovert = scoreName => {
      return {
        value: scoreName,
        text:
          this.$i18n.locale == "zh"
            ? scoreName["fullName"]
            : scoreName["fullName_en"]
      };
    };
    const scoreNames = originScoreNameMap.map(scoreNameCovert);

    const accScoreNames = originAccScoreNameMap.map(scoreNameCovert);
    return {
      is_create_sheet: false,
      canLeave: false,
      sheet: null,
      posted: false,
      composerPosted: false,
      loading: false,
      createComposerLoading: false,
      scoreNames: scoreNames,
      accScoreNames,
      selectedScoreNames: [],
      currentSheet: null,
      originForm: "",
      composerName: "",
      //   albums: this.$store.getters.albums,
      defaultLan: this.$i18n.locale,
      sheetDialog: false,
      dialog: false,
      nameRules: this.$store.getters.nameRules,
      menu: false,
      currentLan: ["base"],
      selectedAlbum: this.$store.getters.currentAlbum,
      fristNewSequenct: 0,
      sheetName: "",
      form: {
        uuid: "",
        belong_album: "",
        name: "",
        scores: []
      },
      composers: [],
      name: {
        base: ""
      },
      scores: [],
      accompaniments: {
        data: {},
        scores: []
      },
      img: {
        add: require("../assets/img/add_icon_blue.svg"),
        close: require("../assets/img/close_img.svg")
      }
    };
    /**
     * instrument: null,
     * author: null
     * musicxmlFile
     * museScoreFile
     */
  },
  components: {
    fileInputButton: FileInputButton,
    mTextInput: MTextInput,
    mSelector: MSelector,
    mSelectorPanel: MSelectorPanel,
    mTextFilter: MTextFilter
  },
  watch: {
    scores: {
      handler: function(newScores) {
        const newSeletedScoreNames = [];
        // A.splice(0,A.length)
        this.selectedScoreNames.splice(0, this.selectedScoreNames.length);
        newScores.forEach(score => {
          if (score.score_data.scoreName) {
            newSeletedScoreNames.push(score.score_data.scoreName);
          }
        });
        this.selectedScoreNames.push(...newSeletedScoreNames);
      },
      deep: true
    }
  },
  created: function() {
    this.is_add_score = this.$route.params.is_add_score;
    this.is_create_sheet = this.$route.params.is_create_sheet;
    this.fristNewSequenct = this.$route.params.sequence;
    this.isZh = this.$i18n.locale === "zh";
    const currentAlbum = this.$store.getters.currentAlbum;
    const currentSheet = this.$store.getters.currentSheet;
    const currentScore = this.$store.getters.currentScore;
    this.currentSheet = currentSheet;

    this.form.belong_album = currentAlbum ? currentAlbum.uuid : "";
    if (currentAlbum && currentAlbum.data.default_lang) {
      this.defaultLan = currentAlbum.data.default_lang;
    }

    const initalScores = {
      isShowSheet: false,
      sequence: 0,
      musicxmlFile: {
        file: null,
        name: null
      },
      museScoreFile: {
        file: null,
        name: null
      },
      score_data: {
        base: {}
      },
      exist_files: {
        musicxmlFile: {
          exist: false,
          name: null
        },
        museScoreFile: {
          exist: false,
          name: null
        }
      }
    };
    if (!currentSheet) {
      this.scores.push(initalScores);
    } else if (this.is_add_score) {
      this.addScore(this.fristNewSequenct);
    } else {
      this.currentLanguage = this.commonUtils.getLanguageFromData(
        currentSheet.data
      );
      this.sheet = currentSheet;
      this.form.uuid = currentSheet.uuid;
      this.form.belong_album = currentSheet.book_uuid;

      this.currentLanguage.forEach(lan => {
        if (currentSheet.data[`name_${lan}`]) {
          this.name[lan] = currentSheet.data[`name_${lan}`];
        }
      });

      const handleScoreData = function(score) {
        const formatedScore = {
          sequence: score.sequence,
          ctype: score.ctype,
          isShowSheet: false,
          uuid: score.uuid,
          musicxmlFile: {
            file: null,
            name: null
          },
          museScoreFile: {
            file: null,
            name: null
          },
          composer_data: score.composer_data,
          composer_uuid: score.composer_uuid,
          score_data: {
            instrument: score.instrument,
            ctime: score.ctime
          },
          files: score.data.files,
          exist_files: {
            musicxmlFile: {
              exist: score.data.files.xml.exist,
              name: score.data.files.xml.name
            },
            museScoreFile: {
              exist: score.data.files.muse_score.exist,
              name: score.data.files.muse_score.name
            }
          },
          sequence: score.sequence
        };

        if (score.data.name) {
          const scoreName = [...this.scoreNames, ...this.accScoreNames].find(
            scoreName => {
              return score.data.name == scoreName.value.fullName;
            }
          );
          if (scoreName) {
            formatedScore.score_data.scoreName = scoreName.value;
          }
        }

        if (score.composer_data) {
          formatedScore.score_data.composer = {
            text: score.composer_data.data.name,
            value: score.composer_data
          };
        }

        if (formatedScore.ctype == "sheet") {
          this.scores.push(formatedScore);
        } else {
          this.accompaniments.scores.push(formatedScore);
        }
      }.bind(this);
      this.commonUtils.getScoresOfSheet(currentSheet.uuid, this).then(
        function(response) {
          response = response.sort(
            (score1, score2) => score1.sequence - score2.sequence
          );

          for (const score of response) {
            handleScoreData(score);
          }

          this.originForm = this.getSnapshot();
        }.bind(this)
      );

      this.commonUtils.getAccOfSheet(currentSheet.uuid, this).then(
        function(response) {

          response.scores = response.scores.sort(
            (score1, score2) => score1.sequence - score2.sequence
          );

          this.accompaniments.uuid = response.uuid;
          for (const score of response.scores) {
            handleScoreData(score);
          }

          this.originForm = this.getSnapshot();
        }.bind(this)
      );
    }

    this.originForm = this.getSnapshot();

    this.commonUtils.getAllComposers(
      this,
      function(composers) {
        console.log("get all composers", composers);
        this.composers = composers.map(function(composer) {
            // let text = composer.data.name;
            let text = '';
            if (composer.owner_uuid == null) {
                if (this.$i18n.locale == 'zh') {
                    text = composer.data.name;
                    if (composer.data.name_en) {
                        text += " - " + composer.data.name_en;
                    }
                } else {
                    if (composer.data.name_en) {
                        text = composer.data.name_en;
                    }
                }
            } else {
                text = composer.data.name;
            }




          return { text, value: composer };
        }.bind(this));

        const resetComposer = score => {
          const composer = this.composers.find(composer => {
            return composer.value.uuid == score.composer_uuid;
          });
          score.score_data.composer = composer;
        };

        this.scores.forEach(resetComposer);

        this.accompaniments.scores.forEach(resetComposer);
      }.bind(this)
    );
  },
  mounted: function() {
    console.log("upload sheet mounted");
  },
  computed: {
    edited: function() {
      const currentForm = this.getSnapshot();
      return currentForm != this.originForm;
    },
    languageList: function() {
      let languageList = this.commonUtils.getLanguageList(this);
      languageList = languageList.filter(lan => {
        if (lan.value == "base") {
          lan.text =
            this.$t("global.text.default_language") +
            "-" +
            this.$t(`global.language.${this.defaultLan}`);
          lan.disable = true;
        } else {
          lan.disable = false;
        }
        if (lan.value == this.defaultLan) {
          return null;
        }
        return lan;
      });
      return languageList;
    },
    currentLanguage: {
      get: function() {
        return this.currentLan;
      },
      set: function(lanList) {
        console.log("set currentLanguage", lanList);
        console.log("set currentLan0", this.currentLan);
        lanList.forEach(lan => {
          if (!this.currentLan.find(l => l == lan)) {
            this.scores.forEach(score => {
              if (!score.score_data || !score.score_data[lan]) {
                score.score_data[lan] = {};
              }
            });

            this.currentLan.push(lan);
          }
        });

        console.log("set currentLan1", this.currentLan);
      }
    },
    albums: function() {
      const albums = this.$store.getters.albums;

      return albums.map(album => {
        const name = this.commonUtils.getDataWithLanguage(this, album, "name");
        return { text: name, value: album };
      });
    },
    instruments: function() {
      const instruments = this.$store.getters.instruments;
      return instruments.map(instrument => {
        return {
          value: instrument,
          text: this.$t(`album.sheet.instrument.${instrument}`)
        };
      });
    }
  },
  methods: {
    getSnapshot() {
      return (
        JSON.stringify(this.scores) +
        JSON.stringify(this.form) +
        JSON.stringify(this.currentLan) +
        JSON.stringify(this.name)
      );
    },
    createComposer(score_data) {
      // score.score_data.composer
      this.composerPosted = true;
      this.createComposerLoading = true;
      if (!this.composerName || this.composerName.length == 0) {
        this.$message({
          message: this.$t("album.sheet.text.composer_name_required"),
          type: "warning"
        });
        return;
      }
      const formData = new FormData();
      formData.append("name", this.composerName);
      console.log("create composer", this.composerName);
      this.commonUtils
        .authenticatedRequest(
          {
            method: "post",
            url: this.commonUtils.getRequestUrl("/composer"),
            data: formData
          },
          this
        )
        .then(
          function(response) {
            this.loading = false;
            const result = response.data;
            this.createComposerLoading = true;
            if (result.success) {
              const composer = result.data;
              console.log("create composer success", composer);
              const item = { text: composer.data.name, value: composer };
              console.log("create composer success", item);
              this.composers.unshift(item);
              score_data.composer = composer;
              this.dialog = false;
            } else {
              console.log("create composer failed", result);
              this.$message({
                message: this.$t("album.sheet.text.create_composer_failed"),
                type: "warning"
              });
            }
          }.bind(this)
        )
        .catch(() => {
          this.loading = false;
          this.$message({
            message: this.$t("album.sheet.text.submit_failed"),
            type: "warning"
          });
        });
    },
    getInstrumentText(instrument) {
      return this.$t(`album.sheet.instrument.${instrument}`);
    },
    getLanguage(lan) {
      //   if (this.currentLanguage.length < 2) {
      //     return null;
      //   }
      if (lan == "base") {
        return this.$t(`global.lan.${this.defaultLan}`);
      } else {
        return this.$t(`global.lan.${lan}`);
      }
    },
    getScoreName: function(index) {},
    isExitMuseScoreFile: function(score) {
      return (
        !!score.museScoreFile.file || !!score.exist_files.museScoreFile.exist
      );
    },
    isExitMusicXMLFile: function(score, i) {
      console.log(
        "isExitMusicXMLFile",
        !!score.musicxmlFile.file || !!score.exist_files.musicxmlFile.exist
      );
      return (
        !!score.musicxmlFile.file || !!score.exist_files.musicxmlFile.exist
      );
    },
    getMusicXMLName(score) {
      if (score.musicxmlFile && score.musicxmlFile.name) {
        return score.musicxmlFile.name;
      } else if (score.files && score.files.xml && score.files.xml.name) {
        return score.files.xml.name;
      }
      return "sheet.xml";
    },
    getMuseScoreName: function(score) {
      if (score.museScoreFile && score.museScoreFile.name) {
        return score.museScoreFile.name;
      } else if (
        score.files &&
        score.files.muse_score &&
        score.files.muse_score.name
      ) {
        return score.files.muse_score.name;
      }
      return "sheet.mscz";
    },
    addScore(seq) {
      let sequence = 0;
      if (seq == null) {
        let maxSequence = 0;
        this.scores.forEach(score => {
          maxSequence =
            score.sequence > maxSequence ? score.sequence : maxSequence;
        });
        sequence = maxSequence + 1;
      } else {
        sequence = seq;
      }

      this.scores.push({
        sequence: sequence,
        musicxmlFile: {
          file: null,
          name: null
        },
        museScoreFile: {
          file: null,
          name: null
        },
        isShowSheet: false,
        score_data: {
          base: {}
        },
        exist_files: {
          musicxmlFile: {
            exist: false,
            name: null
          },
          museScoreFile: {
            exist: false,
            name: null
          }
        }
      });
    },
    addAcc(acc) {
      debugger;
      this.accompaniments.scores.push({
        musicxmlFile: {
          file: null,
          name: null
        },
        museScoreFile: {
          file: null,
          name: null
        },
        isShowSheet: false,
        score_data: {
          base: {}
        },
        exist_files: {
          musicxmlFile: {
            exist: false,
            name: null
          },
          museScoreFile: {
            exist: false,
            name: null
          }
        }
      });
    },
    deleteScore(score, index) {

      if (score.uuid && score.uuid.length > 0) {
        this.$confirm(
          this.$t("album.sheet.text.comfire_delete_score"),
          this.$t("global.text.dialog_notice"),
          {
            confirmButtonText: this.$t("global.text.btn_confirm"),
            cancelButtonText: this.$t("global.text.btn_cancel")
          }
        )
          .then(async () => {
            this.loading = true;

            const result = await this.commonUtils.deleteScoreByUuid(
              score.uuid,
              this
            );
            this.loading = false;
            if (score.ctype == "sheet") {
              if (index > -1) {
                this.scores.splice(index, 1);
              }

              if (this.scores.length == 0) {
                this.addScore();
              }
            } else {
              this.accompaniments.scores.splice(index, 1);
            }
          })
          .catch(() => {});
      } else {
          if (score.ctype == 'sheet') {

            if (this.scores.length < 2) {
            this.$message({
                message: this.$t("album.sheet.text.cannot_empty"),
                type: "error"
            });
            return;
            }

            if (index > -1) {
            this.scores.splice(index, 1);
            }
          } else {
              this.accompaniments.scores.splice(index, 1);
          }
      }
    },

    deleteAcc(acc, index) {
      // TODO:
    },
    submitSheet() {
      this.posted = true;
      let lackTerms = "";

      if (!this.is_add_score) {
        this.currentLanguage.forEach(lan => {
          if (!this.name[lan]) {
            lackTerms +=
              this.$t("album.sheet.text.please_complete_sheet_name") + " ";
          }
        });
      }

      if (!this.selectedAlbum) {
        lackTerms += this.$t("album.sheet.text.album_belong") + " ";
      }

      if (this.scores.length < 1) {
        lackTerms += this.$t("upload_sheet.sheet_file") + " ";
      }

      const scores = this.scores;
      for (let i = 0; i < scores.length; i++) {
        if (
          (!scores[i].musicxmlFile ||
            !scores[i].musicxmlFile.name ||
            !scores[i].museScoreFile ||
            !scores[i].museScoreFile.name) &&
          (!scores[i].exist_files ||
            !scores[i].exist_files.musicxmlFile.exist ||
            !scores[i].exist_files.museScoreFile.exist)
        ) {
          lackTerms = this.$t("album.sheet.text.please_upload_musescore");
        }

        if (!scores[i].score_data.scoreName) {
          lackTerms = this.$t("album.sheet.text.please_choose_score_name");
        }

        if (!scores[i].score_data.composer) {
          lackTerms = this.$t("album.sheet.text.please_choose_composer");
        }

        // if (!scores[i].score_data.instrument) {
        //   lackTerms = this.$t("album.sheet.text.please_choose_score_name");
        // }
      }

      const accScores = this.accompaniments.scores;
      for (let i = 0; i < accScores.length; i++) {
        if (
          (!accScores[i].musicxmlFile ||
            !accScores[i].musicxmlFile.name ||
            !accScores[i].museScoreFile ||
            !accScores[i].museScoreFile.name) &&
          (!accScores[i].exist_files ||
            !accScores[i].exist_files.musicxmlFile.exist ||
            !accScores[i].exist_files.museScoreFile.exist)
        ) {
          debugger;
          lackTerms = this.$t("album.sheet.text.please_upload_musescore");
        }

        // if (!accompaniments[i].score_data.scoreName) {
        //     lackTerms = this.$t("album.sheet.text.please_choose_score_name");
        // }

        if (!accScores[i].score_data.composer) {
          debugger;
          lackTerms = this.$t("album.sheet.text.please_choose_composer");
        }

        // if (!scores[i].score_data.instrument) {
        //   lackTerms = this.$t("album.sheet.text.please_choose_score_name");
        // }
      }
      console.log(lackTerms);
      if (lackTerms) {
        this.$message({
          message:
            this.$t("album.sheet.text.form_not_finished") + ", " + lackTerms,
          type: "error"
        });
        return;
      }

      if (this.form.uuid) {
        this.$confirm(
          this.selectedAlbum.scope == "public"
            ? this.$t("album.sheet.text.public_sheet_after_confirm_edit_sheet")
            : this.$t("album.sheet.text.confirm_edit_sheet"),
          this.$t("global.text.dialog_notice"),
          {
            confirmButtonText: this.$t("global.text.btn_confirm"),
            cancelButtonText: this.$t("global.text.btn_cancel")
          }
        )
          .then(() => {
            this.postSheet();
          })
          .catch(() => {});
      } else {
        this.postSheet();
      }
    },

    async postSheet() {
      const formData = new FormData();

      const scores = this.scores;
      this.loading = true;
      for (let i = 0; i < scores.length; i++) {
        if (!scores[i].score_data) {
          this.$message({
            message: this.$t("sheet.text.score_name"),
            type: "warning"
          });
          this.loading = false;
          return;
        }
        debugger;
        if (
          (!scores[i].musicxmlFile ||
            !scores[i].musicxmlFile.name ||
            !scores[i].museScoreFile ||
            !scores[i].museScoreFile.name) &&
          (!scores[i].exist_files ||
            !scores[i].exist_files.musicxmlFile.exist ||
            !scores[i].exist_files.museScoreFile.exist)
        ) {
          this.$message({
            message: this.$t("sheet.msg.score_file"),
            type: "warning"
          });
          this.loading = false;
          return;
        }
        try {
          if (scores[i].musicxmlFile.file) {
            formData.append(i + "_standard", scores[i].musicxmlFile.file);
            const blob = await this.generatePng(scores[i]);
            formData.append(i + "_cover", blob);
          }
        } catch (e) {
          this.$message({
            message: this.$t("album.sheet.text.xml_error"),
            type: "warning"
          });
          this.loading = false;
          return;
        }

        if (scores[i].museScoreFile.file) {
          formData.append(i + "_musescore", scores[i].museScoreFile.file);
        }

        const scoreData = {};

        for (const key in scores[i].score_data) {
          if (scores[i].score_data.hasOwnProperty(key)) {
            if (this.currentLan.find(lan => lan == key)) {
              const data = scores[i].score_data[key]; //base:
              for (const k in data) {
                if (data.hasOwnProperty(k)) {
                  const element = data[k];
                  scoreData[`${k}_${key}`] = element;
                }
              }
            } else {
              scoreData[key] = scores[i].score_data[key];
            }
          }
        }
        if (scores[i].score_data.scoreName) {
          scoreData.name = scores[i].score_data.scoreName.fullName;
          scoreData.name_en = scores[i].score_data.scoreName.fullName_en;
          scoreData.short_name = scores[i].score_data.scoreName.shortName;
          scoreData.short_name_en = scores[i].score_data.scoreName.shortName_en;
          scoreData.instrument = scores[i].score_data.scoreName.instrument;
        }
        scoreData.uuid = scores[i].uuid;
        if (scores[i].score_data.composer.value) {
          scoreData.composer_uuid = scores[i].score_data.composer.value.uuid;
        } else {
          scoreData.composer_uuid = scores[i].score_data.composer.uuid;
        }

        // scoreName: {…}
        // composer: {…}
        // name: "小提琴"
        // name_en: "Violin"
        // short_name: "小提"
        // short_name_en: "VIn."
        // instrument: "violin"
        // uuid: undefined
        // composer_uuid: "a07819df-e985-4f4a-b46e-3c5fb664d35a"

        formData.append(i + "_score", JSON.stringify(scoreData));
      }

      const accScores = this.accompaniments.scores;
      for (let i = 0; i < accScores.length; i++) {
        if (!accScores[i].score_data) {
          this.$message({
            message: this.$t("sheet.text.score_name"),
            type: "warning"
          });
          this.loading = false;
          return;
        }
        console.log('iiiiii', i);
        debugger;
        if (
          (!accScores[i].musicxmlFile ||
            !accScores[i].musicxmlFile.name ||
            !accScores[i].museScoreFile||
            !accScores[i].museScoreFile.name)
            &&
          (!accScores[i].exist_files ||
            !accScores[i].exist_files.musicxmlFile.exist ||
            !accScores[i].exist_files.museScoreFile.exist
            )
        ) {
          this.$message({
            message: this.$t("sheet.msg.score_file") + '11111',
            type: "warning"
          });
          this.loading = false;
          return;
        }
        if (accScores[i].musicxmlFile.file) {
          formData.append(i + "_accStandard", accScores[i].musicxmlFile.file);
        }
        if (accScores[i].museScoreFile.file) {
          formData.append(i + "_accMusescore", accScores[i].museScoreFile.file);
        }

        const accData = {};

        for (const key in accScores[i].score_data) {
          if (accScores[i].score_data.hasOwnProperty(key)) {
            if (this.currentLan.find(lan => lan == key)) {
              const data = accScores[i].score_data[key]; //base:
              for (const k in data) {
                if (data.hasOwnProperty(k)) {
                  const element = data[k];
                  accData[`${k}_${key}`] = element;
                }
              }
            } else {
              accData[key] = accScores[i].score_data[key];
            }
          }
        }
        if (accScores[i].score_data.scoreName) {
          accData.name = accScores[i].score_data.scoreName.fullName;
          accData.name_en = accScores[i].score_data.scoreName.fullName_en;
          accData.short_name = accScores[i].score_data.scoreName.shortName;
          accData.short_name_en =
            accScores[i].score_data.scoreName.shortName_en;
          accData.instrument = accScores[i].score_data.scoreName.instrument;
        }
        accData.uuid = accScores[i].uuid;
        if (accScores[i].score_data.composer.value) {
          accData.composer_uuid = accScores[i].score_data.composer.value.uuid;
        } else {
          accData.composer_uuid = accScores[i].score_data.composer.uuid;
        }

        // scoreName: {…}
        // composer: {…}
        // name: "小提琴"
        // name_en: "Violin"
        // short_name: "小提"
        // short_name_en: "VIn."
        // instrument: "violin"
        // uuid: undefined
        // composer_uuid: "a07819df-e985-4f4a-b46e-3c5fb664d35a"

        formData.append(i + "_acc", JSON.stringify(accData));
      }

      const sheetData = {};
      let uuid = "";
      if (this.currentSheet && this.currentSheet.uuid) {
        uuid = this.currentSheet.uuid;
      }
      sheetData.uuid = uuid;
      let belong_album = "";
      if (this.selectedAlbum && this.selectedAlbum.uuid) {
        belong_album = this.selectedAlbum.uuid;
      }
      sheetData.belong_album = belong_album;
      sheetData.name = this.name.base;

      for (const lan in this.name) {
        if (this.name.hasOwnProperty(lan)) {
          const name = this.name[lan];
          sheetData[`name_${lan}`] = name;
        }
      }

      formData.append("sheet_data", JSON.stringify(sheetData));

      const accData = {};
      accData.uuid = this.accompaniments.uuid;
      formData.append("acc_data", JSON.stringify(accData));

      this.loading = true;
      this.commonUtils
        .authenticatedRequest(
          {
            method: "post",
            url: this.commonUtils.getRequestUrl("/sheet"),
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
          },
          this
        )
        .then(
          async function(response) {
            this.loading = false;
            const result = response.data;
            console.log("post sheet result", result, response);
            if (result.success) {
              const albums = this.$store.getters.albums;
              this.$store.commit("setCurrentSheet", { sheet: result.sheet });

              const sheetAlbum = albums.find(album => {
                return album.uuid == result.sheet.book_uuid;
              });

              if (sheetAlbum && sheetAlbum.scope == "public") {
                await this.addReview(result.sheet.uuid);
              } else if (sheetAlbum) {
                await this.commonUtils.releaseSheet(result.sheet.uuid, this);
              }

              this.$message({
                message: this.$t("album.sheet.text.submit_success"),
                type: "success"
              });
              this.canLeave = true;
              if (this.is_create_sheet) {
                this.commonUtils.toAlbumDetail(this, sheetAlbum);
              } else {
                this.$router.go(-1);
              }
            } else {
              this.$message({
                message: this.$t("album.sheet.text.submit_failed"),
                type: "warning"
              });
            }
          }.bind(this)
        )
        .catch(() => {
          this.loading = false;
          this.$message({
            message: this.$t("album.sheet.text.submit_failed"),
            type: "warning"
          });
        });
    },
    fileUpdated() {
      console.log("fileUpdated");
      const scores = this.scores;

      scores.forEach((score, index) => {
        const musicXml = this.$refs[`file_musicXml_${index}`][0];
        const museScore = this.$refs[`file_museScore_${index}`][0];

        if (musicXml) {
          score.musicxmlFile.file = musicXml.file;
          score.musicxmlFile.name = musicXml.fileName;
        }
        if (museScore) {
          score.museScoreFile.file = museScore.file;
          score.museScoreFile.name = museScore.fileName;
        }
        console.log("file", musicXml, museScore);
      });

      const accompaniments = this.accompaniments;
      debugger;
      accompaniments.scores.forEach((acc, index) => {
        const musicXml = this.$refs[`acc_file_musicXml_${index}`][0];
        const museScore = this.$refs[`acc_file_museScore_${index}`][0];

        if (musicXml) {
          acc.musicxmlFile.file = musicXml.file;
          acc.musicxmlFile.name = musicXml.fileName;
        }
        if (museScore) {
          acc.museScoreFile.file = museScore.file;
          acc.museScoreFile.name = museScore.fileName;
        }
        console.log("file", musicXml, museScore);
      });
    },
    previewSheetShow(score, index) {
      console.log("previewSheetShow");
      this.sheetDialog = true;
      if (score.musicxmlFile && score.musicxmlFile.file) {
        this.commonUtils.readMusicXML(
          score.musicxmlFile.file,
          function(xml) {
            this.showSheetShow(this.$refs[`sheetShow`], xml);
          }.bind(this)
        );
      } else {
        if (
          score.exist_files &&
          score.exist_files.musicxmlFile &&
          score.exist_files.musicxmlFile.exist &&
          score.files &&
          score.files.xml &&
          score.files.xml.uuid
        ) {
          this.commonUtils.getMusicXMLFromUuid(
            this,
            score.files.xml.uuid,
            function(xml) {
              // this.commonUtils.toSheetShowPreview(this, xml);
              //   this.showSheetShow(this.$refs[`sheetShow_${index}`], xml);
              setTimeout(() => {
                this.showSheetShow(this.$refs[`sheetShow`], xml);
              }, 500);
            }.bind(this)
          );
        }
      }
    },
    showSheetShow(elem, xmlString, maxRow, maxHeight, elemId = "viewer") {
      console.log("SheetShowPreview mounted");
      if (!elem) return;
      elem.innerHTML = "";
      window.SVGHelper.musicSheetId = elemId;
      window.MusicScoreController.viewPortPadding = 100000;
      window.MusicScoreController.shareInstance.reset();
      window.MusicScoreController.shareInstance = new window.MusicScoreController(
        elem
      );
      window.MusicScoreController.shareInstance.loadDataWithXMLString({xmlStr: xmlString});

      window.MusicScoreView.maxHeight = maxHeight;

      console.log("SheetShowPreview mounted1");
      let staveNumber = 1;

      if (window.MeasureCell && window.MeasureCell.staveNumber) {
        staveNumber = window.MeasureCell.staveNumber;
      }

      if (maxRow != null) {
        window.MusicScoreController.shareInstance.addOnDrawMeasuresRowListener(
          (measureIds, rowIndex) => {
            if (rowIndex > maxRow / staveNumber) {
              window.MusicScoreController.shareInstance.genneratorController.isDone = true;
            }
          }
        );
      }

      window.MusicScoreController.shareInstance.shallowTraversal();
      window.MusicScoreController.shareInstance.shallowTraversalToCheckDirection();
      window.MusicScoreController.shareInstance.deepTraversal();
      console.log("SheetShowPreview mounted2");
    },
    async generatePng(score) {
      if (!this.scores || this.scores.length == 0) {
        return null;
      }
      function dataURItoBlob(dataURI) {
        var byteString = atob(dataURI.split(",")[1]);
        var mimeString = dataURI
          .split(",")[0]
          .split(":")[1]
          .split(";")[0];
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
      }

      return new Promise((resolve, reject) => {
        this.commonUtils.readMusicXML(
          score.musicxmlFile.file,
          function(xml) {
            try {
              const screentShoot = document.createElement("div");

              screentShoot.style.width = "768px";
              screentShoot.style.height = "1086px";
              screentShoot.style.backgroundColor = "white";
              screentShoot.style.display = "absolute";
              screentShoot.style.zIndex = "-1";
              screentShoot.id = "screentShoot";

              document.body.appendChild(screentShoot);
              let staveNumber = 1;

              this.showSheetShow(screentShoot, xml, 8, 900, screentShoot.id);
              setTimeout(() => {
                console.log("domtoimage", domtoimage, screentShoot);
                domtoimage
                  .toPng(screentShoot, {
                    style: { display: "block", height: "724px" }
                  })
                  .then(function(dataUrl) {
                    const blob = dataURItoBlob(dataUrl);
                    screentShoot.parentNode.removeChild(screentShoot);
                    resolve(blob);
                  })
                  .catch(function(e) {
                    reject(e);
                  });
              }, 2000);
            } catch (e) {
              reject(e);
            }
          }.bind(this)
        );
      });
      return;
      this.commonUtils.getMusicXMLFromUuid(
        this,
        score.files.xml.uuid,
        function(xml) {
          const screentShoot = document.createElement("div");
          document.body.appendChild(screentShoot);
          let staveNumber = 1;

          this.showSheetShow(screentShoot, xml, 8);
          setTimeout(() => {
            domtoimage
              .toPng(screentShoot, { style: { display: "block" } })
              .then(function(dataUrl) {
                const blob = dataURItoBlob(dataUrl);
                callback(blob);
              });
          }, 1000);
        }.bind(this)
      );

      // this.commonUtils.readMusicXML(
      //   score.musicxmlFile.file,
      //   function(xml) {
      //     const screentShoot = document.createElement('div');
      //     document.body.appendChild(screentShoot);
      //     this.showSheetShow(screentShoot, xml);
      //     domtoimage.toPng(sheetShow)
      //     .then(function (dataUrl) {
      //         screentShoot.remove();
      //         console.log('dataUrl', dataUrl);
      //         var img = new Image();
      //         img.src = dataUrl;
      //         document.body.appendChild(img);
      //     })
      //     .catch(function (error) {
      //         console.error('oops, something went wrong!', error);
      //     });
      //   }.bind(this)
      // );
    },
    addReview: function(sheetUuid) {
      this.commonUtils
        .addReviews(this, "sheet updated", sheetUuid)
        .then(function(reviews) {
          console.log(reviews);
        });
    },
    createAlbum() {
      // this.$store.commit("setRouteBackTo", {route_back_to: 'upload_sheet'});
      // this.$store.commit("setCurrentAlbum", {album: null});
      this.$router.push({
        name: "create_album",
        params: { is_from_create_sheet: true }
      });
    },
    clickAddLanguage() {},
    isDisableScoreName(item) {
      return this.selectedScoreNames.includes(item);
    },
    cancel() {
      const backTo = this.$store.getters.routeBackTo;

      if (backTo) {
        this.$router.replace({ name: backTo });
      } else {
        this.$router.go(-1);
      }
    }
  },
  beforeRouteLeave: async function(to, from, next) {
    if (!this.canLeave && this.edited) {
      setTimeout(() => {
        this.$confirm(
          this.$t("global.text.is_confirm_give_up_change"),
          this.$t("global.text.dialog_notice"),
          {
            confirmButtonText: this.$t("global.text.btn_confirm"),
            cancelButtonText: this.$t("global.text.btn_cancel")
          }
        ).then(() => {
          console.log("set can leave true");
          this.canLeave = true;
          this.$router.push({ name: to.name });
        });
      }, 500);
    }
    if (this.canLeave || !this.edited) {
      console.log("can leave");
      next(true);
    } else {
      console.log("can not leave");
      next(false);
    }
  }
};
</script>

<style scoped>
@import "../assets/css/common.css";

.upload-file-title {
  width: 220px;
}
.create-composer-title {
  font-size: 20px;
  /* font-family: SHRegular; */
  font-weight: normal;
}
.upload-file {
  width: 400px;
  height: 62px;
  line-height: 62px;
  text-align: center;
  border-width: 1px;
  border-color: #e3e3e3;
  border-style: dashed;
}

.btn-title {
  font-size: 20px;
}

.add-score-btn {
  background-color: white;
  box-shadow: 0px 0px 8px 4px rgba(50, 141, 255, 0.22) !important;
}

.add-language-btn {
  border-width: 1px !important;
  border-color: #e3e3e3 !important;
  border-style: solid !important;
  border-radius: 13px !important;
}

.file-btn-title {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sheet-show {
  widows: 800px;
}

.file-remind {
  border-color: #e62e2e;
  background-color: #f8dede;
}

.composer-form {
  /* padding-top: 24px; */
  /* height: 64px; */
  /* border-radius: 0 !important;
  border-width: 1px !important;
  border-color: #e3e3e3 !important;
  border-style: solid !important;
  overflow: hidden; */
}

.composer-form-reminding {
  border-color: #e3e3e3 !important;
}

.create-composer {
  cursor: pointer;
}
/* .create-composer {
  cursor: pointer;
} */

.red-point {
  background-color: #e62e2e;
  border-radius: 3.5px;
  width: 7px;
  height: 7px;
}
</style>
